<template>
  <div class="calico-financial-documents">
    <CalicoBanner
      v-if="error"
      variant="error"
      :fixed="true"
    >
      {{ error }}
    </CalicoBanner>
    <div class="financial-documents-header">
      <h3 class="heading--xsmall">
        {{ title }}
      </h3>
      <div class="accepted-formats">
        <p class="body--xsmall">
          {{ acceptedFormatsLabel }}
        </p>
        <ul>
          <li class="body--xsmall">
            {{ acceptedFormats1 }}
          </li>
          <li class="body--xsmall">
            {{ acceptedFormats2 }}
          </li>
        </ul>
      </div>
    </div>
    <div class="financial-documents-content">
      <slot />
    </div>
  </div>
</template>

<script>
import CalicoBanner from '@/components/calico/banner/index.vue'
import { LoanBeaconCopy } from '@/enums/index.js'

export default {
  name: 'CalicoFinancialDocuments',

  components: {
    CalicoBanner,
  },

  props: {
    error: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      title: LoanBeaconCopy.FINANCIAL_DOCUMENTS_TITLE,
      acceptedFormatsLabel: LoanBeaconCopy.FINANCIAL_DOCUMENTS_ACCEPTED_FORMATS_LABEL,
      acceptedFormats1: LoanBeaconCopy.FINANCIAL_DOCUMENTS_ACCEPTED_FORMATS_1,
      acceptedFormats2: LoanBeaconCopy.FINANCIAL_DOCUMENTS_ACCEPTED_FORMATS_2,
    }
  },
}
</script>

<style scoped lang="scss">
.calico-financial-documents {
  @include stack-space($space-none);
  width: 100%;
  background: $color-neutral-lightest;
  flex: 1;

  .financial-documents-header {
    @include inset-space($space-medium);
    @include stack-space($space-xsmall);
    align-self: stretch;

    .accepted-formats {
      color: $color-text-secondary;
    }

    ul {
      @include stack-space($space-none);
      padding-left: $space-medium;
      list-style: disc;
    }
  }

  .financial-documents-content {
    @include stack-space($space-small);
    @include inset-space($space-medium);
    flex: 1;
    align-self: stretch;
  }
}
</style>